module.exports = __webpack_public_path__ + "fonts/fa-brands-400.5e2f921.woff2";